<template>
  <div class="d-flex">
    <note-save-dialog
      :note="note"
      @submit:success="$emit('submit:success')"
      @submit:fail="$emit('submit:fail')"
    >
      <template #activator="{ on }">
        <button-tooltip
          :tooltip-text="$t('fresh-vue-notes.misc.edit')"
          icon="$freshvuenotes-edit"
          v-bind="$attrs"
          :loading="loading"
          v-on="on"
        />
      </template>
    </note-save-dialog>

    <button-tooltip
      :tooltip-text="$t('fresh-vue-notes.misc.delete')"
      icon="$freshvuenotes-delete"
      v-bind="$attrs"
      :loading="loading"
      @click="onDelete"
    />
  </div>
</template>

<script>
import gql from 'graphql-tag'
import { AlertUtils } from '@freshsolutions/fresh-vue'

import { ButtonTooltip } from '@freshsolutions/fresh-vue'
import NoteSaveDialog from './NoteSaveDialog'

export default {
  name: 'NotesListNoteActions',

  components: {
    ButtonTooltip,
    NoteSaveDialog
  },

  props: {
    note: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      loading: false
    }
  },

  methods: {
    onDelete() {
      AlertUtils.fireQuestion({
        text: 'Möchten Sie die Notiz wirklich löschen?'
      }).then((result) => {
        if (result.value) {
          this.loading = true
          this.$apollo
            .mutate({
              mutation: gql`
                mutation deleteNote($id: ID!) {
                  deleteNote(id: $id) {
                    id
                  }
                }
              `,
              variables: {
                id: this.note.id
              }
            })
            .then(() => {
              this.loading = false
              this.$emit('submit:success')
            })
            .catch(() => {
              this.loading = false
              this.$emit('submit:fail')
            })
        }
      })
    }
  }
}
</script>
